<div class="mb-6">
  <div class="grid grid-cols-[repeat(auto-fit,300px)] gap-4">
    <!-- Planned dates -->
    <app-timeframe-planned-dates-card [config]="config()" />

    <!-- Initial sub-phase -->
    @if (config().currentPhase?.initialSubPhase; as subPhase) {
      <app-timeframe-sub-phase-card
        [projectId]="projectId()"
        [subPhase]="subPhase"
        shippingLabelKey="project.steps.invitationList.shippingDate"
        submissionLabelKey="project.steps.invitationList.submissionDate"
        shippingTestId="shipping-date"
        submissionTestId="submission-date"
        [editable]="initialEditable()"
        (submissionDateUpdated)="submissionDateUpdated.emit()"
      />
    }

    <!-- Extended sub-phase -->
    @if (config().currentPhase?.extendedSubPhase; as subPhase) {
      <app-timeframe-sub-phase-card
        [projectId]="projectId()"
        [subPhase]="subPhase"
        shippingLabelKey="project.steps.invitationList.extendedShippingDate"
        submissionLabelKey="project.steps.invitationList.extendedSubmissionDate"
        shippingTestId="extended-shipping-date"
        submissionTestId="extended-submission-date"
        [editable]="extendedEditable()"
        (submissionDateUpdated)="submissionDateUpdated.emit()"
      />
    }

    <!-- Final sub-phase -->
    @if (config().currentPhase?.finalSubPhase; as subPhase) {
      <app-timeframe-sub-phase-card
        [projectId]="projectId()"
        [subPhase]="subPhase"
        shippingLabelKey="project.steps.invitationList.finalShippingDate"
        submissionLabelKey="project.steps.invitationList.submissionDate"
        shippingTestId="final-shipping-date"
        submissionTestId="final-submission-date"
        [editable]="true"
        (submissionDateUpdated)="submissionDateUpdated.emit()"
      />
    }
  </div>
</div>
